import { Button, DatePicker, Modal, Result } from 'antd'
import React from 'react'

const ScheduleModel = ({openScheduleModel,handleCancelScheduleModel,HandleScheduleTime,HandleSchedule, loading = false, scheduleSelected = false}) => {
    return (
        <Modal
            title="Schedule Campaign"
            open={openScheduleModel}
            onCancel={handleCancelScheduleModel}
            footer={null}
        >
            <Result
                status="success"
                title="Select date and Time"
                extra={
                    <>
                        <DatePicker
                            showTime={{ format: 'HH:mm' }}
                            format="YYYY-MM-DD HH:mm"
                            onChange={(value) => HandleScheduleTime(value)}
                            style={{ width: '100%', marginBottom: 16 }}
                        />
                        <Button
                            type="primary"
                            onClick={() => HandleSchedule()}
                            loading={loading}
                            disabled={!scheduleSelected}
                        >
                            Schedule Campaign
                        </Button>
                    </>
                }
            />
        </Modal>
    )
}

export default ScheduleModel
